<template>
  <div class="errorBlock text-center p-3">
    <b-col> Chyba aplikace.</b-col>
    <b-col>
      {{ message }}
    </b-col>
  </div>
</template>

<script>
export default {
  props: ["message"],
};
</script>
